import table_messages from 'messages/table_messages';
import { StaticTableFilter } from 'types/TableFilter';

import booleanDictionary from '../../booleanDictionary';

//     "only_my_assets": true,

const myAssetsFilter: StaticTableFilter = {
  isDynamic: false,
  sectionName: table_messages.assets_filters.is_my_assets,
  filters: booleanDictionary,
  isSingleSelect: true,
};

export default myAssetsFilter;
